import React, { useState } from 'react';
import { Table, Form, Input, Select, Statistic, Button } from 'antd';
import { LikeOutlined, DislikeOutlined } from '@ant-design/icons';
const { Option } = Select;
var _ = require('lodash');

const columns = [
    {
        title: 'Parameter',
        dataIndex: 'parameter',
        width: 250,
        onCell: (_, index) => {
            if (index === 0) {
                return { rowSpan: 4 };
            }
            if (index > 3) {
                return {}
            }
            return { rowSpan: 0 };
        },
    },
    {
        title: 'Safety Parameter',
        dataIndex: 'sub_parameter',
    },
    {
        title: "Feedback",
        dataIndex: "feedback",
        width: 350,
        render: (_, record) => {
            if (record.disabled) {
                return <p>{record.selected_option}</p>
            }
            return <Form.Item
                name={record.key}
                rules={[{ required: true, message: "Please select" }]}
            >
                <Select defaultValue={record.score} onSelect={(score) => record.updateFunction(record.key, score)}>
                    {record.input_options.map(item => <Option value={item.score}>{item.option}</Option>)}
                </Select>
            </Form.Item>
        },
    },
    {
        title: 'Score',
        dataIndex: 'score',
        width: 200,
        align: "center",
        key: 'score',
    },
];

const parameters = [
    {
        key: 'lti_happen',
        category: 'Safety',
        parameter: '',
        sub_parameter: 'Did any LTI happen',
        input_options: [{ option: 'Yes', score: 0 }, { option: 'No', score: 4 }],
        score: 0,
        weight: 20,
        weighted_score: 0,
    },
    {
        key: 'safety_case',
        category: 'Safety',
        parameter: '',
        sub_parameter: 'First Aid Case/ Restricted Work Case/ Medical Treatment case',
        input_options: [{ option: '0', score: 4 }, { option: '1', score: 3 }, { option: '2', score: 2 }, { option: '3', score: 1 }, { option: '4 & above', score: 0 }],
        score: 0,
        weight: 15,
        weighted_score: 0,
    },
    {
        key: 'fire_property_case',
        category: 'Safety',
        parameter: '',
        sub_parameter: 'Fire + Property Damage case',
        input_options: [{ option: '0', score: 4 }, { option: '1', score: 3 }, { option: '2', score: 2 }, { option: '3', score: 1 }, { option: '4 & above', score: 0 }],
        score: 0,
        weight: 10,
        weighted_score: 0,
    },
    {
        key: 'safety_officer_deployment',
        category: 'Safety',
        parameter: '',
        sub_parameter: 'Deployment of Safety Marshals and Safety Engineers',
        input_options: [{ option: 'As per Contract', score: 4 }, { option: '5% shortfall against the contract requirement', score: 3 }, { option: '10% shortfall against the contract requirement', score: 2 }, { option: '15% shortfall against the contract requirement', score: 1 }, { option: '20% or more than 20% shortfall against the contract requirement', score: 0 }],
        score: 0,
        weight: 15,
        weighted_score: 0,
    },
    {
        key: 'field_observations',
        category: 'Safety',
        parameter: 'Workplace safety',
        sub_parameter: 'Avg. no. of safety Non-conformance/ Field Observations in the month against 50 headcount',
        input_options: [{ option: '>=30', score: 4 }, { option: '29 - 21', score: 3 }, { option: '20 - 11', score: 2 }, { option: '10', score: 1 }, { option: '<10', score: 0 }],
        score: 0,
        weight: 20,
        weighted_score: 0,
    },
    {
        key: 'safety_compliance',
        category: 'Safety',
        parameter: 'Safety observation compliance',
        sub_parameter: 'Compliance to safety observations',
        input_options: [{ option: '>=95% compliance', score: 4 }, { option: '90%-94% compliance', score: 3 }, { option: '80%-89% compliance', score: 2 }, { option: '70%-79% compliance', score: 1 }, { option: '<70%', score: 0 }],
        score: 0,
        weight: 20,
        weighted_score: 0,
    },
    {
        key: 'fatality',
        category: 'Safety',
        parameter: 'Fatality',
        sub_parameter: 'Did any fatality happen in the month/ Period',
        input_options: [{ option: 'Yes', score: 0 }, { option: 'No', score: 4 }],
        score: 0,
        weight: 0,
        weighted_score: 0,
    },
];

const SafetyFeedback = ({ updateScore, disabled, initialValues }) => {

    const updateData = (key, score) => {
        let count = 0

        let updateData = data.map(item => {
            
            if (item.key == key) {
                item.score = score
                item.weighted_score = (score * item.weight) / 100
            }

            if (item.key == 'fatality' && item.score == 0) {
                count = 0
            } else {
                count = count + item.weighted_score
            }

            return item;
        })
        setWeightedScore(count)
        setData(updateData)
        updateScore("Safety", updateData)
    }

    const [weightedScore, setWeightedScore] = useState(0)

    const [data, setData] = useState(() => {
        let count = 0;
        let fatalityOccured = false
        let updatedParameters = parameters.map(item => {
            item.updateFunction = updateData
            item.disabled = disabled
            if (initialValues) {
                let option = initialValues.scores.filter(x => x.key == item.key)
                if (option.length > 0) {
                    item.selected_option = option[0].selected_option
                    item.score = option[0].score
                    item.weighted_score = option[0].weighted_score
                    count += option[0].weighted_score
                    if (item.key == 'fatality' && item.score == 0) {
                        fatalityOccured = true
                    }
                } else {
                    item.selected_option = ""
                }
            }
            return item;
        })
        if (fatalityOccured) {
            setWeightedScore(0)
        } else {
            setWeightedScore(count)
        }
        return updatedParameters;
    });

    return (
        <>
            {!disabled && <>
                <div style={{ padding: "10px", float: "right", marginRight: "15px", background: "white", border: "1px solid lightgray", borderRadius: "10px" }}>
                    <Statistic
                        title={"Overall Safety"}
                        valueStyle={{ color: weightedScore <=2 ? '#b22222' : weightedScore <=3 ? '#ff6347': weightedScore <=3.5 ? '#ffd700': '#32cd32' }}
                        prefix={weightedScore < 3 ? <DislikeOutlined /> : <LikeOutlined />}
                        value={weightedScore}
                        precision={2} />
                </div>
                <br /><br /><br /><br /></>}
            <div className='form-box' >
                {(initialValues.scores.some(obj => obj.category === 'Safety')) ?
                    <div className='score-legend' 
                        style={{ background: weightedScore <=2 ? '#b22222' : weightedScore <=3 ? '#ff6347': weightedScore <=3.5 ? '#ffd700': '#32cd32' }}>
                        <p style={{ margin: "0px" }}>Overall Safety Score - {weightedScore.toFixed(2)}</p>
                    </div> :
                    <div className='score-legend' style={{ background: '#838383' }}>
                        <p style={{ margin: "0px" }}>Safety Feedback Pending</p>
                    </div>}
                <Table
                    size="small"
                    bordered={true}
                    columns={columns}
                    pagination={false}
                    dataSource={_.cloneDeep(data)}
                />
            </div>


        </>
    );
}
export default SafetyFeedback;